export enum EmployeeCategory{
    Doctor,
    HeadOfDoctor,
    Nurse,
    Registrator,
    HeadOfDepartment
}